// assets/facetService.js

const ALGOLIA_APP_ID = "AH80R61Z2R";
const ALGOLIA_SEARCH_KEY = "95a0bd9d5238bca651821399645560a7";
const ALGOLIA_INDEX_NAME = "shopify_algoliaproducts";

let DEFAULT_TYPE = "ポケモン";

const PRELOAD_PLAN = {
  "ポケモン": [
    "product_type",
    "meta.custom.custom_rarity_v2",
    "meta.custom.custom_attribute_v2",
    "meta.custom.custom_retreat_cost_v2",
    "meta.custom.custom_effect_v2",
    "meta.custom.custom_special_rule_v2",
    "meta.custom.custom_growth_stage_v2",
    "meta.custom.custom_regulation_v2",
    "meta.custom.custom_box_name_view_v2",
    "meta.custom.custom_illustrator_v2",
    "meta.custom.custom_generation_v2",
    "meta.custom.custom_card_types_v2",
  ],
  "ワンピース": [
    "product_type",
    "meta.custom.custom_rarity_v2",
    "meta.custom.custom_attribute_v2",
    "meta.custom.custom_regulation_v2",
    "meta.custom.custom_mark_1_v2",
    "meta.custom.custom_box_name_view_v2",
    "meta.custom.custom_illustrator_v2",
    "meta.custom.custom_mark_4_v2",
    "meta.custom.custom_category_1_v2",
    "meta.custom.custom_mark_3_v2",
    "meta.custom.custom_language_v2",
    "meta.custom.custom_card_types_v2",
  ],
};

const __storeByType = new Map();

function extractGenerationNumber(label) {
  // "第10世代" / "10" / "第 10 世代" みたいなのも吸収
  const m = String(label).match(/(\d+)/);
  return m ? parseInt(m[1], 10) : Number.POSITIVE_INFINITY;
}

function sortFacetValues(facet, values) {
  if (facet === "meta.custom.custom_generation_v2") {
    return values.sort((a, b) => extractGenerationNumber(a) - extractGenerationNumber(b));
  }
  return values.sort(); // それ以外は今まで通り辞書順
}

function getStore(type) {
  if (!__storeByType.has(type)) {
    __storeByType.set(type, { loaded: false, loadingPromise: null, data: {} });
  }
  return __storeByType.get(type);
}

async function testEX() {
  const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
  const index  = client.initIndex(ALGOLIA_INDEX_NAME);

  const rEX = await index.search("", {
    filters: 'meta.custom.custom_special_rule_v2:"EX"',
    hitsPerPage: 0,
  });

  const rex = await index.search("", {
    filters: 'meta.custom.custom_special_rule_v2:"ex"',
    hitsPerPage: 0,
  });

  console.log("EX nbHits:", rEX.nbHits);
  console.log("ex nbHits:", rex.nbHits);
}

export async function preloadAllFacetValues(type) {
  const facetList = PRELOAD_PLAN[type] || [];
  const store = getStore(type);

  if (facetList.length === 0) {
    store.loaded = true;
    store.data = {};
    console.log("[preloadAllFacetValues] facetList empty for type:", type);
    return store.data;
  }

  if (store.loaded) return store.data;
  if (store.loadingPromise) return store.loadingPromise;

  const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
  const index  = client.initIndex(ALGOLIA_INDEX_NAME);

  store.loadingPromise = index.search(type, {
    restrictSearchableAttributes: ["product_type"], 
    facets: facetList,                               
    hitsPerPage: 0,
    maxValuesPerFacet: 2000,
  }).then((res) => {
    const out = {};
    for (const facet of facetList) {
      const dist = res.facets?.[facet] || {};
      // out[facet] = Object.keys(dist)
      //   .map(v => String(v).trim())
      //   .filter(v => v && v !== "-")
      //   .sort();
      const values = Object.keys(dist)
        .map(v => String(v).trim())
        .filter(v => v && v !== "-");

      out[facet] = sortFacetValues(facet, values);

    }

    store.data = out;
    store.loaded = true;

    return out;
  }).catch((err) => {
    console.error("❌ preload failed", { type, facets: facetList, err });
    throw err;
  }).finally(() => {
    store.loadingPromise = null;
  });

  return store.loadingPromise;
}


/**
 * ✅ 可选：页面加载时一口气预加载多个 type（每个 type 1 次 search）
 */
export async function preloadFacetValuesForTypes(types) {
  const unique = Array.from(new Set(types.filter(Boolean)));
  await Promise.all(unique.map(t => preloadAllFacetValues(t)));
}

export async function fetchAllUniqueEnergyValuesList(FACET_ATTR, type = undefined) {
  const effectiveType = type ?? DEFAULT_TYPE;

  await preloadAllFacetValues(effectiveType);

  const store = getStore(effectiveType);

  if (store.data?.[FACET_ATTR]) return store.data[FACET_ATTR];

  const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
  const index = client.initIndex(ALGOLIA_INDEX_NAME);
    console.info("index.search",FACET_ATTR,type)
  const res = await index.search("", {
    facetFilters: [`product_type:${effectiveType}`],
    facets: [FACET_ATTR],
    hitsPerPage: 0,
    maxValuesPerFacet: 2000,
  });
  const dist = res.facets?.[FACET_ATTR] || {};
  // return Object.keys(dist)
  //   .map(v => String(v).trim())
  //   .filter(v => v && v !== "-")
  //   .sort();

  const values = Object.keys(dist)
    .map(v => String(v).trim())
    .filter(v => v && v !== "-");

  return sortFacetValues(FACET_ATTR, values);
}

export function setDefaultFacetType(type) {
  DEFAULT_TYPE = type;
}

window.fetchAllUniqueEnergyValuesList = fetchAllUniqueEnergyValuesList;

const __storeExcludingMainTypes = { loaded: false, loadingPromise: null, data: {} };

/**
 * product_type が ポケモン・ワンピース 以外の全データを取得する
 * 結果はページリロードまでキャッシュされる
 * @param {string[]} facetAttrs - 取得したい facet 属性のリスト（省略時は product_type のみ）
 * @returns {Promise<Object>} facet ごとの値リスト
 */
export async function fetchFacetValuesExcludingMainTypes(facetAttrs = ["product_type"]) {
  if (__storeExcludingMainTypes.loaded) return __storeExcludingMainTypes.data;
  if (__storeExcludingMainTypes.loadingPromise) return __storeExcludingMainTypes.loadingPromise;

  const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
  const index = client.initIndex(ALGOLIA_INDEX_NAME);

  const EXCLUDE_KEYWORDS = ["ポケモン", "ワンピース"];

  __storeExcludingMainTypes.loadingPromise = index.search("", {
    facets: facetAttrs,
    hitsPerPage: 0,
    maxValuesPerFacet: 2000,
  }).then((res) => {
    const out = {};
    for (const facet of facetAttrs) {
      const dist = res.facets?.[facet] || {};
      const values = Object.keys(dist)
        .map(v => String(v).trim())
        .filter(v => v && v !== "-")
        .filter(v => !EXCLUDE_KEYWORDS.some(kw => v.includes(kw)));
      out[facet] = sortFacetValues(facet, values);
    }

    __storeExcludingMainTypes.data = out;
    __storeExcludingMainTypes.loaded = true;

    return out;
  }).catch((err) => {
    console.error("❌ fetchFacetValuesExcludingMainTypes failed", { facetAttrs, err });
    throw err;
  }).finally(() => {
    __storeExcludingMainTypes.loadingPromise = null;
  });

  return __storeExcludingMainTypes.loadingPromise;
}

window.fetchFacetValuesExcludingMainTypes = fetchFacetValuesExcludingMainTypes;
